export default "https://cdn-static.gokick.com/assets/29e4076df1e4180397d7539366c975103b08717a/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";